import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

// i18n must be initialized before rendering the app
import "./lib/i18n";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
